module.exports = __webpack_public_path__ + "img/lobby_hosting_zgw3.336fd51e.png";